module.exports = __webpack_public_path__ + "static/media/princ.8f8dceb6.png";